import Tidal from '../../pages-dynamic/info/tidal/seller-rental-agreement';
import BotMart from '../../pages-dynamic/info/botmart/seller-rental-agreement';

export default process.env.WHITE_LABEL_ORG === 'botmart' ? BotMart : Tidal;
